/**
 * WEEK 33 MASTER DICTIONARY DATABASE (CAMBRIDGE A2 FLYERS)
 * Strict Whitelist with Morphological Aliases (V-ing, V-ed, V-s, Plurals).
 * Professional ESL definitions, IPA, contextual examples, and alias mappings.
 */

export const WEEK_33_MASTER_DICTIONARY = {
  // --- 10 LEXICAL CHUNKS & COLLOCATIONS ---
  "slipped on the wet floor": {
    type: "Collocation",
    ipa: "/slɪpt ɑːn ðə wɛt flɔːr/",
    meaning: "trượt chân ngã trên nền sàn ướt",
    example: "Tom ran fast and slipped on the wet floor near the science lab.",
    audioText: "slipped on the wet floor",
    aliases: [
      "slip on the wet floor",
      "slipping on the wet floor",
      "slips on the wet floor",
      "slipped on a wet floor",
      "slip on a wet floor"
    ]
  },
  "yellow warning sign": {
    type: "Collocation",
    ipa: "/ˈjɛloʊ ˈwɔːrnɪŋ saɪn/",
    meaning: "biển báo cảnh báo màu vàng",
    example: "Always watch out for the yellow warning sign when the floor is mopped.",
    audioText: "yellow warning sign",
    aliases: [
      "yellow warning signs",
      "a yellow warning sign"
    ]
  },
  "hurt his knee": {
    type: "Collocation",
    ipa: "/hɜːrt hɪz niː/",
    meaning: "bị đau đầu gối",
    example: "Tom fell down heavily and hurt his knee during recess.",
    audioText: "hurt his knee",
    aliases: [
      "hurting his knee",
      "hurts his knee",
      "hurt her knee",
      "hurt my knee",
      "hurt their knees",
      "hurt his leg"
    ]
  },
  "call the school nurse": {
    type: "Collocation",
    ipa: "/kɔːl ðə skuːl nɜːrs/",
    meaning: "gọi y tế trường học",
    example: "Jake acted responsibly and decided to call the school nurse right away.",
    audioText: "call the school nurse",
    aliases: [
      "called the school nurse",
      "calling the school nurse",
      "calls the school nurse"
    ]
  },
  "clean bandage": {
    type: "Collocation",
    ipa: "/kliːn ˈbændɪdʒ/",
    meaning: "băng gạc sạch",
    example: "The school nurse applied a clean bandage to protect the cut.",
    audioText: "clean bandage",
    aliases: [
      "clean bandages",
      "a clean bandage"
    ]
  },
  "cold pack": {
    type: "Collocation",
    ipa: "/koʊld pæk/",
    meaning: "túi chườm lạnh",
    example: "The nurse used a cold pack to reduce the swelling on his knee.",
    audioText: "cold pack",
    aliases: [
      "cold packs",
      "a cold pack"
    ]
  },
  "walk carefully": {
    type: "Collocation",
    ipa: "/wɔːk ˈkɛrfəli/",
    meaning: "đi bộ cẩn thận",
    example: "Students must walk carefully in the school corridor to prevent accidents.",
    audioText: "walk carefully",
    aliases: [
      "walking carefully",
      "walked carefully",
      "walks carefully",
      "was walking carefully",
      "were walking carefully"
    ]
  },
  "was walking carefully": {
    type: "Grammar / Verb Phrase",
    ipa: "/wəz ˈwɔːkɪŋ ˈkɛrfəli/",
    meaning: "đang đi bộ cẩn thận (thì quá khứ tiếp diễn Past Continuous)",
    example: "Jake was walking carefully in the school corridor when the cleaner was working.",
    audioText: "was walking carefully",
    aliases: [
      "were walking carefully",
      "walking carefully"
    ]
  },
  "was drying": {
    type: "Grammar / Verb Phrase",
    ipa: "/wəz ˈdraɪɪŋ/",
    meaning: "đang lau khô (thì quá khứ tiếp diễn Past Continuous)",
    example: "The cleaner was drying the wet floor with a mop.",
    audioText: "was drying",
    aliases: [
      "were drying",
      "is drying",
      "drying"
    ]
  },
  "was running quickly": {
    type: "Grammar / Verb Phrase",
    ipa: "/wəz ˈrʌnɪŋ ˈkwɪkli/",
    meaning: "đang chạy nhanh (hành động đang diễn ra trong quá khứ)",
    example: "Tom was running quickly to class, so he slipped on the wet tiles.",
    audioText: "was running quickly",
    aliases: [
      "were running quickly",
      "running quickly",
      "run quickly"
    ]
  },
  "stops things from sliding": {
    type: "Grammar / Verb Phrase",
    ipa: "/stɑːps θɪŋz frəm ˈslaɪdɪŋ/",
    meaning: "ngăn đồ vật không bị trượt (nguyên lý ma sát - thì hiện tại đơn)",
    example: "Friction is the science force that stops things from sliding on smooth floors.",
    audioText: "stops things from sliding",
    aliases: [
      "stop things from sliding",
      "stops objects from sliding",
      "stop objects from sliding"
    ]
  },
  "slide easily": {
    type: "Grammar / Verb Phrase",
    ipa: "/slaɪd ˈiːzəli/",
    meaning: "bị trượt đi một cách dễ dàng",
    example: "Water reduces friction, so shoes slide easily across the tiles.",
    audioText: "slide easily",
    aliases: [
      "slides easily",
      "sliding easily",
      "slid easily"
    ]
  },
  "provide strong grip": {
    type: "Grammar / Verb Phrase",
    ipa: "/prəˈvaɪd strɔːŋ ɡrɪp/",
    meaning: "tạo độ bám dính chắc chắn vào mặt sàn",
    example: "Rubber shoe soles provide strong grip on smooth corridor tiles.",
    audioText: "provide strong grip",
    aliases: [
      "provides strong grip",
      "providing strong grip",
      "provided strong grip"
    ]
  },
  "keeps everyone safe": {
    type: "Grammar / Verb Phrase",
    ipa: "/kiːps ˈɛvriwʌn seɪf/",
    meaning: "giúp mọi người luôn được an toàn",
    example: "Understanding friction and following safety rules keeps everyone safe.",
    audioText: "keeps everyone safe",
    aliases: [
      "keep everyone safe",
      "keeping everyone safe",
      "kept everyone safe"
    ]
  },
  "holds": {
    type: "Verb",
    ipa: "/hoʊldz/",
    meaning: "giữ / bám dính (nguyên lý bám bề mặt)",
    example: "Rubber holds surfaces better than smooth plastic.",
    audioText: "holds",
    aliases: ["hold", "holding", "held"]
  },
  "remind": {
    type: "Verb",
    ipa: "/rɪˈmaɪnd/",
    meaning: "nhắc nhở / lưu ý",
    example: "Yellow warning signs remind students to walk slowly.",
    audioText: "remind",
    aliases: ["reminds", "reminded", "reminding"]
  },
  "creates": {
    type: "Verb",
    ipa: "/kriˈeɪts/",
    meaning: "tạo ra (nguyên lý khoa học)",
    example: "Water on smooth tiles creates a thin slippery layer.",
    audioText: "creates",
    aliases: ["create", "creating", "created"]
  },
  "walks": {
    type: "Verb",
    ipa: "/wɔːks/",
    meaning: "đi bộ (ngôi thứ 3 số ít thì hiện tại đơn)",
    example: "When a student walks on dry tiles, shoe soles grip the floor firmly.",
    audioText: "walks",
    aliases: ["walk", "walking", "walked"]
  },
  "headmaster office": {
    type: "Collocation",
    ipa: "/ˈhɛdmæstər ˈɔːfɪs/",
    meaning: "phòng hiệu trưởng",
    example: "The headmaster praised Jake for his quick action in the headmaster office.",
    audioText: "headmaster office",
    aliases: [
      "headmaster's office",
      "headmaster offices",
      "the headmaster office"
    ]
  },
  "corridor safety": {
    type: "Collocation",
    ipa: "/ˈkɔːrɪdɔːr ˈseɪfti/",
    meaning: "an toàn hành lang",
    example: "Corridor safety is everyone's responsibility at our school.",
    audioText: "corridor safety",
    aliases: [
      "safety in the corridor",
      "school corridor safety"
    ]
  },
  "quick action": {
    type: "Collocation",
    ipa: "/kwɪk ˈækʃən/",
    meaning: "hành động nhanh chóng / xử lý kịp thời",
    example: "Thanks to Jake's quick action, Tom received medical help immediately.",
    audioText: "quick action",
    aliases: [
      "quick actions",
      "his quick action"
    ]
  },

  // --- 20 CORE VOCABULARY WORDS ---
  "corridor": {
    type: "Noun",
    ipa: "/ˈkɔːrɪdɔːr/",
    meaning: "hành lang trường học",
    example: "Jake was walking down the school corridor after science class.",
    audioText: "corridor",
    aliases: ["corridors", "hallway", "hallways"]
  },
  "slipped": {
    type: "Verb",
    ipa: "/slɪpt/",
    meaning: "bị trượt chân (quá khứ của slip)",
    example: "Tom ran too fast and slipped on the wet tiles.",
    audioText: "slipped",
    aliases: ["slip", "slipping", "slips"]
  },
  "nurse": {
    type: "Noun",
    ipa: "/nɜːrs/",
    meaning: "y tá / y sĩ trường học",
    example: "The school nurse came quickly with first aid supplies.",
    audioText: "nurse",
    aliases: ["nurses"]
  },
  "bandage": {
    type: "Noun",
    ipa: "/ˈbændɪdʒ/",
    meaning: "băng cá nhân / băng gạc",
    example: "She put a clean bandage on his injured knee.",
    audioText: "bandage",
    aliases: ["bandages"]
  },
  "relieved": {
    type: "Adjective",
    ipa: "/rɪˈliːvd/",
    meaning: "an tâm / nhẹ nhõm",
    example: "Everyone felt relieved when they knew Tom was okay.",
    audioText: "relieved",
    aliases: ["relieve", "relieving"]
  },
  "mistake": {
    type: "Noun",
    ipa: "/mɪˈsteɪk/",
    meaning: "lỗi lầm / sai sót",
    example: "Running in the hallway is a dangerous mistake.",
    audioText: "mistake",
    aliases: ["mistakes"]
  },
  "accident": {
    type: "Noun",
    ipa: "/ˈæksɪdənt/",
    meaning: "tai nạn / sự cố bất ngờ",
    example: "We can prevent most accidents by following safety rules.",
    audioText: "accident",
    aliases: ["accidents"]
  },
  "fix": {
    type: "Verb",
    ipa: "/fɪks/",
    meaning: "sửa chữa / khắc phục",
    example: "The janitor quickly cleaned up the spill to fix the hazard.",
    audioText: "fix",
    aliases: ["fixes", "fixed", "fixing"]
  },
  "sorry": {
    type: "Adjective",
    ipa: "/ˈsɑːri/",
    meaning: "cảm thấy tiếc / xin lỗi",
    example: "Tom said he was sorry for running in the corridor.",
    audioText: "sorry",
    aliases: []
  },
  "careful": {
    type: "Adjective",
    ipa: "/ˈkɛrfəl/",
    meaning: "cẩn thận",
    example: "Please be careful when carrying hot soup in the cafeteria.",
    audioText: "careful",
    aliases: ["carefully"]
  },
  "clumsy": {
    type: "Adjective",
    ipa: "/ˈklʌmzi/",
    meaning: "vềnh vàng / vụng về",
    example: "He dropped his books because he was being clumsy.",
    audioText: "clumsy",
    aliases: ["clumsily"]
  },
  "arm": {
    type: "Noun",
    ipa: "/ɑːrm/",
    meaning: "cánh tay",
    example: "He scraped his arm slightly when he fell.",
    audioText: "arm",
    aliases: ["arms"]
  },
  "knee": {
    type: "Noun",
    ipa: "/niː/",
    meaning: "đầu gối",
    example: "Tom hit his knee hard against the hard floor.",
    audioText: "knee",
    aliases: ["knees"]
  },
  "leg": {
    type: "Noun",
    ipa: "/lɛɡ/",
    meaning: "chân",
    example: "He stretched his leg to make sure it wasn't broken.",
    audioText: "leg",
    aliases: ["legs"]
  },
  "head": {
    type: "Noun",
    ipa: "/hɛd/",
    meaning: "đầu",
    example: "Always wear a helmet to protect your head while cycling.",
    audioText: "head",
    aliases: ["heads"]
  },
  "recover": {
    type: "Verb",
    ipa: "/rɪˈkʌvər/",
    meaning: "hồi phục / bình phục",
    example: "Tom needed a few days to fully recover from his fall.",
    audioText: "recover",
    aliases: ["recovers", "recovered", "recovering"]
  },
  "explain": {
    type: "Verb",
    ipa: "/ɪkˈspleɪn/",
    meaning: "giải thích",
    example: "The teacher asked Tom to explain what happened.",
    audioText: "explain",
    aliases: ["explains", "explained", "explaining"]
  },
  "lesson": {
    type: "Noun",
    ipa: "/ˈlɛsən/",
    meaning: "bài học kinh nghiệm",
    example: "That day taught everyone a valuable safety lesson.",
    audioText: "lesson",
    aliases: ["lessons"]
  },
  "terrible": {
    type: "Adjective",
    ipa: "/ˈtɛrəbəl/",
    meaning: "tệ hại / khủng khiếp",
    example: "It felt like a terrible accident, but thankfully he recovered quickly.",
    audioText: "terrible",
    aliases: ["terribly"]
  },
  "friction": {
    type: "Noun",
    ipa: "/ˈfrɪkʃən/",
    meaning: "lực ma sát (lực cản trở chuyển động trượt)",
    example: "Friction is a force that stops things from sliding.",
    audioText: "friction",
    aliases: ["high friction", "low friction", "frictional"]
  },
  "slippery floor": {
    type: "Collocation",
    ipa: "/ˈslɪpəri flɔːr/",
    meaning: "sàn nhà trơn trượt",
    example: "Water on tiles creates a slippery floor.",
    audioText: "slippery floor",
    aliases: ["slippery tiles", "slippery surface", "slippery"]
  },
  "rubber shoes": {
    type: "Collocation",
    ipa: "/ˈrʌbər ʃuːz/",
    meaning: "giày đế cao su",
    example: "Wearing rubber shoes creates high friction and keeps you safe.",
    audioText: "rubber shoes",
    aliases: ["rubber shoe", "rubber-soled shoes", "rubber sole"]
  },
  "high friction": {
    type: "Collocation",
    ipa: "/haɪ ˈfrɪkʃən/",
    meaning: "lực ma sát lớn (giúp bám sàn tốt)",
    example: "His rubber shoes created high friction with the dry floor.",
    audioText: "high friction",
    aliases: ["high grip and friction"]
  },
  "wet floors": {
    type: "Collocation",
    ipa: "/wɛt flɔːrz/",
    meaning: "các sàn nhà bị ướt",
    example: "Why do we fall on wet floors?",
    audioText: "wet floors",
    aliases: ["wet floor", "wet tiles", "slippery tiles"]
  },
  "sliding": {
    type: "Verb",
    ipa: "/ˈslaɪdɪŋ/",
    meaning: "sự trượt đi / trượt ngã",
    example: "Friction stops shoes and wheels from sliding on the ground.",
    audioText: "sliding",
    aliases: ["slide", "slides", "slid"]
  },
  "puddle": {
    type: "Noun",
    ipa: "/ˈpʌdəl/",
    meaning: "vũng nước nhỏ trên sàn",
    example: "His shoes hit the wet puddle near the science room.",
    audioText: "puddle",
    aliases: ["puddles", "wet puddle", "water puddle"]
  },
  "grip": {
    type: "Noun",
    ipa: "/ɡrɪp/",
    meaning: "độ bám dính / lực bám sàn",
    example: "Rubber soles provide strong grip on smooth corridor tiles.",
    audioText: "grip",
    aliases: ["grips", "gripping", "gripped"]
  },
  "rubber soles": {
    type: "Collocation",
    ipa: "/ˈrʌbər soʊlz/",
    meaning: "đế giày bằng cao su giúp bám sàn tốt",
    example: "Wearing shoes with rubber soles prevents slipping on smooth floors.",
    audioText: "rubber soles",
    aliases: ["rubber sole", "rubber-soled shoes"]
  },
  "shoe soles": {
    type: "Collocation",
    ipa: "/ʃuː soʊlz/",
    meaning: "đế giày (phần dưới của giày tiếp xúc với mặt sàn)",
    example: "Shoe soles grip dry tiles firmly and keep you balanced.",
    audioText: "shoe soles",
    aliases: ["shoe sole", "soles of shoes", "soles"]
  },
  "reduces friction": {
    type: "Collocation",
    ipa: "/rɪˈdjuːsɪz ˈfrɪkʃən/",
    meaning: "làm giảm lực ma sát (khiến đồ vật dễ trượt ngã)",
    example: "This water layer reduces friction, so shoes slide easily.",
    audioText: "reduces friction",
    aliases: ["reduce friction", "reducing friction", "reduced friction"]
  },
  "stays balanced": {
    type: "Collocation",
    ipa: "/steɪz ˈbælənst/",
    meaning: "giữ được thăng bằng vững vàng (không bị ngã)",
    example: "High friction helps the student stay balanced on the floor.",
    audioText: "stays balanced",
    aliases: ["stay balanced", "staying balanced", "stayed balanced"]
  },
  "strong grip": {
    type: "Collocation",
    ipa: "/strɔːŋ ɡrɪp/",
    meaning: "độ bám dính chắc chắn vào mặt sàn",
    example: "Rubber soles provide strong grip on smooth corridor tiles.",
    audioText: "strong grip",
    aliases: ["good grip", "high grip"]
  },
  "school corridor": {
    type: "Collocation",
    ipa: "/skuːl ˈkɔːrɪdɔːr/",
    meaning: "hành lang trong trường học",
    example: "Jake was walking carefully down the school corridor.",
    audioText: "school corridor",
    aliases: ["school corridors", "the school corridor"]
  },
  "smooth tiles": {
    type: "Collocation",
    ipa: "/smuːð taɪlz/",
    meaning: "gạch lát sàn trơn nhẵn",
    example: "Smooth tiles become very slippery when water is spilled on them.",
    audioText: "smooth tiles",
    aliases: ["smooth tile", "tiles", "tile", "floor tiles"]
  },
  "wet tiles": {
    type: "Collocation",
    ipa: "/wɛt taɪlz/",
    meaning: "sàn gạch ướt (dễ gây trơn trượt)",
    example: "Tom was running quickly and slipped on the wet tiles.",
    audioText: "wet tiles",
    aliases: ["wet tile", "wet floor tiles"]
  },
  "slippery layer": {
    type: "Collocation",
    ipa: "/ˈslɪpəri ˈleɪər/",
    meaning: "lớp màng trơn trượt do nước tạo ra trên sàn",
    example: "Water on the tiles forms a thin slippery layer that reduces friction.",
    audioText: "slippery layer",
    aliases: ["slippery layers", "thin layer", "thin slippery layer"]
  },
  "water layer": {
    type: "Collocation",
    ipa: "/ˈwɔːtər ˈleɪər/",
    meaning: "lớp màng nước mỏng trên mặt phẳng",
    example: "This water layer reduces friction, so shoes slide easily.",
    audioText: "water layer",
    aliases: ["water layers", "thin water layer"]
  },
  "warning signs": {
    type: "Collocation",
    ipa: "/ˈwɔːrnɪŋ saɪnz/",
    meaning: "các biển báo cảnh báo nguy hiểm",
    example: "Yellow warning signs remind students to walk slowly.",
    audioText: "warning signs",
    aliases: ["warning sign", "caution sign", "yellow warning sign", "yellow warning signs"]
  },
  "warning sign": {
    type: "Collocation",
    ipa: "/ˈwɔːrnɪŋ saɪn/",
    meaning: "biển báo cảnh báo nguy hiểm",
    example: "The yellow warning sign alerts students to walk slowly.",
    audioText: "warning sign",
    aliases: ["warning signs", "caution sign"]
  },
  "balance": {
    type: "Noun",
    ipa: "/ˈbæləns/",
    meaning: "sự thăng bằng / giữ thăng bằng",
    example: "Good friction between shoes and floor helps you stay balanced.",
    audioText: "balance",
    aliases: ["balanced", "balancing", "balances"]
  },
  "surface": {
    type: "Noun",
    ipa: "/ˈsɜːrfɪs/",
    meaning: "bề mặt tiếp xúc",
    example: "Friction is the physical grip between two contacting surfaces.",
    audioText: "surface",
    aliases: ["surfaces", "floor surface"]
  },
  "plastic soles": {
    type: "Collocation",
    ipa: "/ˈplæstɪk soʊlz/",
    meaning: "đế giày bằng nhựa trơn (kém ma sát, dễ trượt ngã)",
    example: "His sneakers had smooth plastic soles with no grip on wet tiles.",
    audioText: "plastic soles",
    aliases: ["plastic sole", "smooth plastic soles", "plastic shoe soles"]
  },
  "invisible science force": {
    type: "Collocation",
    ipa: "/ɪnˈvɪzəbl ˈsaɪəns fɔːrs/",
    meaning: "lực khoa học vô hình (như lực ma sát)",
    example: "The secret is an invisible science force called friction!",
    audioText: "invisible science force",
    aliases: ["invisible force", "science force", "an invisible science force"]
  },
  "slipped on the wet tiles": {
    type: "Collocation",
    ipa: "/slɪpt ɑːn ðə wɛt taɪlz/",
    meaning: "trượt chân trên sàn gạch ướt",
    example: "Tom slipped on the wet tiles because his shoes had no grip.",
    audioText: "slipped on the wet tiles",
    aliases: ["slip on the wet tiles", "slipping on the wet tiles", "slips on the wet tiles"]
  },
  "was running in a big hurry": {
    type: "Collocation",
    ipa: "/wəz ˈrʌnɪŋ ɪn ə bɪɡ ˈhɜːri/",
    meaning: "đang chạy rất vội vã",
    example: "Tom was running in a big hurry to science class.",
    audioText: "was running in a big hurry",
    aliases: ["running in a big hurry", "run in a big hurry", "in a big hurry"]
  },
  "gripped the floor tightly": {
    type: "Collocation",
    ipa: "/ɡrɪpt ðə flɔːr ˈtaɪtli/",
    meaning: "bám chặt vào mặt sàn",
    example: "His own rubber soles gripped the floor tightly without sliding.",
    audioText: "gripped the floor tightly",
    aliases: ["grip the floor tightly", "gripping the floor tightly", "grips the floor tightly", "gripped firmly"]
  },
  "stops you from sliding": {
    type: "Collocation",
    ipa: "/stɑːps juː frəm ˈslaɪdɪŋ/",
    meaning: "ngăn bạn không bị trượt ngã",
    example: "Friction is the friendly grip that stops you from sliding.",
    audioText: "stops you from sliding",
    aliases: ["stop you from sliding", "stopping you from sliding", "stops things from sliding", "stop things from sliding"]
  },
  "water steals your friction": {
    type: "Collocation",
    ipa: "/ˈwɔːtər stiːlz jɔːr ˈfrɪkʃn/",
    meaning: "nước làm mất lực ma sát (lấy cắp ma sát)",
    example: "Rubber gives strong grip, but water always steals your friction!",
    audioText: "water steals your friction",
    aliases: ["steals your friction", "water steals friction", "steal your friction"]
  },
  "smart scientist": {
    type: "Collocation",
    ipa: "/smɑːrt ˈsaɪəntɪst/",
    meaning: "nhà khoa học thông thái",
    example: "From now on, I will walk like a smart scientist!",
    audioText: "smart scientist",
    aliases: ["walk like a smart scientist", "smart scientists"]
  },
  "ice rinks": {
    type: "Collocation",
    ipa: "/aɪs rɪŋks/",
    meaning: "sân trượt băng",
    example: "Did you ever wonder why wet floors turn into ice rinks?",
    audioText: "ice rinks",
    aliases: ["ice rink", "an ice rink"]
  },
  "slippery slide": {
    type: "Collocation",
    ipa: "/ˈslɪpəri slaɪd/",
    meaning: "cầu trượt trơn trượt nguy hiểm",
    example: "This water layer turns safe floors into a slippery slide!",
    audioText: "slippery slide",
    aliases: ["slippery slides", "a slippery slide"]
  },
  "applied a clean bandage": {
    type: "Collocation",
    ipa: "/əˈplaɪd ə kliːn ˈbændɪdʒ/",
    meaning: "băng bó bằng băng gạc sạch",
    example: "The nurse applied a clean bandage to protect the cut.",
    audioText: "applied a clean bandage",
    aliases: ["apply a clean bandage", "applying a clean bandage"]
  },
  "special safety award": {
    type: "Collocation",
    ipa: "/ˈspɛʃl ˈseɪfti əˈwɔːrd/",
    meaning: "giải thưởng an toàn đặc biệt",
    example: "The headmaster gave Jake a special safety award during assembly.",
    audioText: "special safety award",
    aliases: ["safety award", "a special safety award"]
  },
  "felt proud of him": {
    type: "Collocation",
    ipa: "/fɛlt praʊd əv hɪm/",
    meaning: "cảm thấy tự hào về bạn ấy",
    example: "All the teachers and students felt proud of him.",
    audioText: "felt proud of him",
    aliases: ["feel proud of him", "feeling proud of him"]
  },
  "spoke to all the students": {
    type: "Collocation",
    ipa: "/spoʊk tuː ɔːl ðə ˈstjuːdnts/",
    meaning: "nói chuyện trước toàn thể học sinh",
    example: "The headmaster spoke to all the students about corridor safety.",
    audioText: "spoke to all the students",
    aliases: ["speak to all the students", "speaking to all the students"]
  },
  "lost his balance": {
    type: "Collocation",
    ipa: "/lɔːst hɪz ˈbæləns/",
    meaning: "bị mất thăng bằng",
    example: "The running boy slipped on the wet tiles and lost his balance.",
    audioText: "lost his balance",
    aliases: ["lose his balance", "losing his balance", "lost balance"]
  },
  "the running boy": {
    type: "Noun Phrase",
    ipa: "/ðə ˈrʌnɪŋ bɔɪ/",
    meaning: "cậu bé đang chạy",
    example: "The running boy was in a big hurry to science class.",
    audioText: "the running boy",
    aliases: ["running boy", "a running boy"]
  },
  "near the blue lockers": {
    type: "Prepositional Phrase",
    ipa: "/nɪr ðə bluː ˈlɑːkərz/",
    meaning: "gần dãy tủ khóa màu xanh",
    example: "He slipped and fell down heavily near the blue lockers.",
    audioText: "near the blue lockers",
    aliases: ["by the blue lockers", "near the lockers"]
  },
  "hurt his left knee badly": {
    type: "Collocation",
    ipa: "/hɜːrt hɪz lɛft niː ˈbædli/",
    meaning: "bị thương đau nặng ở đầu gối trái",
    example: "He fell down heavily and hurt his left knee badly.",
    audioText: "hurt his left knee badly",
    aliases: ["hurt his left knee", "hurt his knee badly"]
  },
  "cried out in pain": {
    type: "Collocation",
    ipa: "/kraɪd aʊt ɪn peɪn/",
    meaning: "kêu lên vì đau đớn",
    example: "The boy cried out in pain when he bumped his knee.",
    audioText: "cried out in pain",
    aliases: ["cry out in pain", "crying out in pain"]
  },
  "first-aid kit": {
    type: "Noun",
    ipa: "/ˌfɜːrst ˈeɪd kɪt/",
    meaning: "hộp dụng cụ sơ cứu y tế",
    example: "The school nurse brought a first-aid kit with bandages and cold packs.",
    audioText: "first-aid kit",
    aliases: ["a first-aid kit", "first aid kit", "first-aid kits"]
  },
  "stayed with his hurt classmate": {
    type: "Collocation",
    ipa: "/steɪd wɪð hɪz hɜːrt ˈklæsmeɪt/",
    meaning: "ở bên cạnh người bạn cùng lớp bị đau",
    example: "Jake stayed with his hurt classmate until the nurse arrived.",
    audioText: "stayed with his hurt classmate",
    aliases: ["stay with his hurt classmate", "staying with his hurt classmate"]
  },
  "the school nurse arrived quickly": {
    type: "Collocation",
    ipa: "/ðə skuːl nɜːrs əˈraɪvd ˈkwɪkli/",
    meaning: "cô y tá trường học đã đến rất nhanh",
    example: "Jake called for help and the school nurse arrived quickly.",
    audioText: "the school nurse arrived quickly",
    aliases: ["nurse arrived quickly", "arrived quickly"]
  },
  "placed a blue cold pack": {
    type: "Collocation",
    ipa: "/pleɪst ə bluː koʊld pæk/",
    meaning: "chườm túi chườm lạnh màu xanh",
    example: "The nurse placed a blue cold pack on his swollen knee.",
    audioText: "placed a blue cold pack",
    aliases: ["place a blue cold pack", "cold pack", "placed a cold pack"]
  },
  "Headmaster Brown": {
    type: "Proper Noun",
    ipa: "/ˌhɛdˈmæstər braʊn/",
    meaning: "thầy hiệu trưởng Brown",
    example: "Headmaster Brown spoke to all the students about corridor safety.",
    audioText: "Headmaster Brown",
    aliases: ["headmaster", "the headmaster"]
  },
  "explained the corridor safety rules": {
    type: "Collocation",
    ipa: "/ɪkˈspleɪnd ðə ˈkɔːrɪdɔːr ˈseɪfti ruːlz/",
    meaning: "giải thích các quy tắc an toàn hành lang",
    example: "He explained the corridor safety rules during the morning assembly.",
    audioText: "explained the corridor safety rules",
    aliases: ["explain the corridor safety rules", "corridor safety rules"]
  },
  "never run on wet floors": {
    type: "Collocation",
    ipa: "/ˈnɛvər rʌn ɑːn wɛt flɔːrz/",
    meaning: "không bao giờ chạy trên sàn ướt",
    example: "Safety rule number one: never run on wet floors!",
    audioText: "never run on wet floors",
    aliases: ["never run on wet floor", "never run near a wet floor"]
  },
  "at the school assembly": {
    type: "Prepositional Phrase",
    ipa: "/æt ðə skuːl əˈsɛmbli/",
    meaning: "tại buổi lễ chào cờ / tập trung toàn trường",
    example: "Jake received a special award at the school assembly.",
    audioText: "at the school assembly",
    aliases: ["school assembly", "during the school assembly"]
  },
  "all the students and teachers": {
    type: "Noun Phrase",
    ipa: "/ɔːl ðə ˈstjuːdnts ænd ˈtiːtʃərz/",
    meaning: "toàn thể học sinh và giáo viên",
    example: "All the students and teachers clapped and cheered for Jake.",
    audioText: "all the students and teachers",
    aliases: ["students and teachers", "all students and teachers"]
  },
  "handed him a certificate": {
    type: "Collocation",
    ipa: "/ˈhændɪd hɪm ə sərˈtɪfɪkət/",
    meaning: "trao cho bạn ấy một giấy chứng nhận",
    example: "Headmaster Brown handed him a certificate of bravery and care.",
    audioText: "handed him a certificate",
    aliases: ["hand him a certificate", "handed Jake a certificate"]
  },
  "promised to walk carefully": {
    type: "Collocation",
    ipa: "/ˈprɑːmɪst tuː wɔːk ˈkerfəli/",
    meaning: "hứa sẽ đi lại cẩn thận",
    example: "Tom rubbed his knee and promised to walk carefully from now on.",
    audioText: "promised to walk carefully",
    aliases: ["promise to walk carefully", "promising to walk carefully"]
  },
  "were clapping loudly": {
    type: "Collocation",
    ipa: "/wɜːr ˈklæpɪŋ ˈlaʊdli/",
    meaning: "đang vỗ tay nhiệt liệt",
    example: "Everyone was clapping loudly when Jake stepped on stage.",
    audioText: "were clapping loudly",
    aliases: ["clapping loudly", "clapped loudly"]
  }
};

// Backward compatible array export
export const week33MasterDictionary = Object.entries(WEEK_33_MASTER_DICTIONARY).map(([word, item]) => ({
  word,
  pronounce: item.ipa,
  meaning: item.meaning,
  example: item.example,
  type: item.type,
  audioText: item.audioText,
  aliases: item.aliases || []
}));

export default WEEK_33_MASTER_DICTIONARY;
